import React, { Component } from 'react';
import './GroupUserListPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import mainAPI from '../../api/MainAPI';
import Button from '../../components/button/Button';
import CardHeader from '../../components/cardHeader/CardHeader';
import EditAgencyPopup from '../../popups/editAgencyPopup/EditAgencyPopup';
import ImportUsersPopup from '../../popups/importUsersPopup/ImportUsersPopup';
import toasts from '../../utils/toasts';
import utils from '../../utils/utils';
import CheckBox from '../../inputs/checkBox/CheckBox';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';

export const urls = {
	'http://localhost:3000': 'http://localhost:3000',
	'http://localhost:3001': 'http://localhost:3001',
	'https://admin.logrx.com': 'https://app.logrx.com',
	'https://super-admin.logrx.com': 'https://app.logrx.com',
	'https://dev-admin.logrx.com': 'https://dev.logrx.com'
};
let adminUrls = {
	'http://localhost:3000': 'http://localhost:3000',
	'http://localhost:3001': 'http://localhost:3001',
	'https://admin.logrx.com': 'https://admin.logrx.com',
	'https://super-admin.logrx.com': 'https://admin.logrx.com',
	'https://dev-admin.logrx.com': 'https://dev-admin.logrx.com'
};

const categoryOptions = ['Veterinary', 'Law Enforcement', 'Controlled Substance', 'Non-Controlled Substance', 'Blood Products'];

export default class GroupUserListPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			userGroup: {}
		};
	}

	componentDidMount = async () => {
		await this.getData();
	};

	getData = async () => {
		let users = await mainAPI.user.for_group(this.props.match.params.userGroupId);
		let disabledCategories = await mainAPI.disabled_drug_type_category.all(this.props.match.params.userGroupId);
		let userGroup = await mainAPI.user_group.getAsSuperAdmin({id:this.props.match.params.userGroupId});
		let userGroupSettings = await userGroupSettingsManager.refresh(this.props.match.params.userGroupId);
		this.setState({ users, disabledCategories, userGroup, userGroupSettings });
	};

	updateAgency = async (details) => {
		try {
			await mainAPI.user_group.updateMetaData({ id: this.props.match.params.userGroupId, ...details });
			toasts.show('Agency updated');
		} catch (e) {
			toasts.show('Failed to update Agency');
		}
	};

	toggleAgencyOverdueInvoice = async () => {
		try {
			await mainAPI.user_group.updateMetaData({ id: this.props.match.params.userGroupId, has_overdue_invoice:!this.state.userGroup.has_overdue_invoice ? 1:0 });
      await this.getData();
			toasts.show('Agency updated');
		} catch (e) {
			toasts.show('Failed to update Agency');
		}
	};

	togglenarcLock = async (value) => {
		value = value ? 1 : 0;
		const {userGroup: {id: user_group_id} = {}} = this.state
		try {
			await mainAPI.user_group.updateMetaData({ id: user_group_id, narc_lock_integration_enabled: value });
			await this.getData();
			toasts.show('NarcLock updated for Agency');
		} catch (e) {
			toasts.show('Failed to update NarcLock for Agency');
		}
	}

	toggleKnox = async (value) => {
		value = value ? 1 : 0;
		const {userGroup: {id: user_group_id} = {}} = this.state
		try {
			await mainAPI.user_group.updateMetaData({ id: user_group_id, enable_knox_integration: value });
			await this.getData();
			toasts.show(`Knox ${value? 'enabled': 'disabled'} for Agency`);
		} catch (e) {
			toasts.show('Failed to update Knox for Agency');
		}
	}

	toggleSensors = async (value) => {
		value = value ? 1 : 0;
		const {userGroup: {id: user_group_id} = {}} = this.state
		try {
			await userGroupSettingsManager.upsert({name:'allow_temperature_sensor', value, user_group_id});
			await this.getData();
			toasts.show(`Sensors ${value? 'enabled': 'disabled'} for Agency`);
		} catch (e) {
			toasts.show('Failed to update Sensors for Agency');
		}
	}

	disableCategory = async (value, categoryName, {id} = {}) => {
		const {match: {params: {userGroupId: user_group_id__manual} = {}} = {params: {}}} = this.props;
		if (value) {
			const {id: deletedId} = await mainAPI.disabled_drug_type_category.delete({id,
				notes: `Deleting "${categoryName}" for user_group_id: ${user_group_id__manual}. id: ${id}`
			});
			if (id === deletedId) toasts.show(`${categoryName} is now enabled`);
			else toasts.show(`Error enabling ${categoryName} category`);
		}
		else {
			const response = await mainAPI.disabled_drug_type_category.create({user_group_id__manual, category_name: categoryName});
			const {category_name, err: {response: {data: {err}}} = {response: {data: {}}}} = response;
			if(category_name) { toasts.show(`${category_name} is now disabled`); }
			else if(err) { toasts.show(err); }
			else { toasts.show('Failed to disable category'); }
		}
		const disabledCategories = await mainAPI.disabled_drug_type_category.all(user_group_id__manual);
		this.setState({ disabledCategories });
	};

	logInAsUser = async (user) => {
		const storage = await this.getLocalStorageForUser(user);
		window.location = urls[window.location.origin] + '?storage=' + encodeURIComponent(JSON.stringify(storage)) + '#set-storage'
	};

	logInAsAdmin = async (user) => {
		const storage = await this.getLocalStorageForUser(user);
		const url = adminUrls[window.location.origin] + '?storage=' + encodeURIComponent(JSON.stringify(storage)) + '#set-storage'
		console.log(url);
		window.open(url, '_blank');
	};

	getLocalStorageForUser = async (user) => {
		const response = await mainAPI.api_region.find_region({token:user.token});
		return {
			user_group_id : this.props.match.params.userGroupId,
			token : user.token,
			last_log_in : Date.now(),
			num_additional_groups : 2,
			region: response.region
		}
	};


	_renderUsers = () => {
		let display = [<div className="row" key={0}><Label black>Name</Label><Label black>Email</Label><Label black>Inactive for</Label><Label black>Role</Label><Label black></Label></div>];

		for (let i in this.state.users) {
			let user = this.state.users[i];
			display.push(
				<div className="row" key={user.id}>
					<Label black>{user.first_name + ' ' + user.last_name}</Label>
					<Label black>{user.primary_email}</Label>
					<Label black>{!Number.isNaN(user.last_active_on.getTime()) && ((Date.now() - (new Date(user.last_active_on)).getTime()) / 1000 / 60/ 60/ 24).toFixed(1) + ' Days'} </Label>
					<Label black>{utils.capitalizeWords(user.role.replace(/_/g, ' '))}</Label>
					<div className='btn-col'>
						{user.role != 'user' &&

							<Button
								bg="blue"
								color="white"
								onClick={() => {
									this.logInAsAdmin(user);
								}}
							>
								Admin Login
							</Button>

						}
						<Button
							bg="blue"
							color="white"
							onClick={() => {
								this.logInAsUser(user);
							}}
						>
							App Login
						</Button>
					</div>
				</div>
			);
		}
		return display;
	};

	renderEditBtn = () => {
		return (
				<Button
					bg="blue"
					color="white"
					onClick={() => {
						window.popupController.show(EditAgencyPopup, {
							title: 'Edit the Agency name',
							onComplete: (details) => {
								this.updateAgency(details);
							}
						});
					}}
				>
					Edit Agency Name
				</Button>
		);
	};

	renderOverduePaymentButton = () => {
    const userGroup = this.state.userGroup || {};
    const text = userGroup.has_overdue_invoice ? 'Set invoice as paid' : 'Set invoice as overdue'
    const bg = userGroup.has_overdue_invoice ? 'blue' : 'red'
		return (
				<Button
					bg={bg}
					color="white"
					onClick={this.toggleAgencyOverdueInvoice}
				>
          {text}
				</Button>
		);
	};

	renderImportUsersButton = () => {
		return (
				<Button
					bg="blue"
					color="white"
					onClick={() => {
						window.popupController.show(ImportUsersPopup, {
							userGroupId: this.props.match.params.userGroupId,
							onComplete: () => {
								this.getData();
							}
						});
					}}
				>
					Import Users
				</Button>
		);
	};

	_renderCategories = () => {
		let disabledCategories = this.state.disabledCategories;
		let disabledCategoryNames = [];
		let allCategories = [];

		for (let i in disabledCategories) {
			if (disabledCategories[i].category_name) {
				disabledCategoryNames.push(disabledCategories[i].category_name);
			}
		}

		for (let i in categoryOptions) {
			const {id} = (disabledCategories || []).find(({category_name}) => category_name === categoryOptions[i]) || {}
			let iconOrCheckbox = (
				<CheckBox
					value={!disabledCategoryNames.includes(categoryOptions[i])}
					onChange={(value) => {
						this.disableCategory(value, categoryOptions[i], {id});
					}}
				/>
			);

			allCategories.push(
				<div className="checkbox-row" key={allCategories}>
					{iconOrCheckbox}
					<Label black>{categoryOptions[i]}</Label>
				</div>
			);
		}
		return allCategories;
	};

	_renderSettings = () => {
		const allow_temperature_sensor = userGroupSettingsManager.getSetting('allow_temperature_sensor');
		return <>
			<Label className="settings-header" black large>Settings</Label>

			<div className="checkbox-row" key="sensors-integration">
				<CheckBox value={allow_temperature_sensor} onChange={this.toggleSensors}/>
				<Label black>Temperature Sensors/Blood Coolers</Label>
			</div>
		</>
	}
	_renderIntegrations = () => {
		const {userGroup: {enable_knox_integration} = {}} = this.state
		return (<>
			<Label className="settings-header" black large>Integrations</Label>
			{/*<div className="checkbox-row" key="narc-lock-integration">*/}
			{/*	<CheckBox value={!!narcLockEnabled}  onChange={this.togglenarcLock}/>*/}
			{/*	<Label black>NarcLock</Label>*/}
			{/*</div>*/}
			<div className="checkbox-row" key="knox-integration">
				<CheckBox value={!!enable_knox_integration} onChange={this.toggleKnox}/>
				<Label black>Knox</Label>
			</div>
		</>);
	}

	render() {
		return (
			<Page className="g-group-user-list-page">
				<Card className={'main-card'}>
					<div className={'top-buttons'}>
						{this.renderEditBtn()}
						{this.renderOverduePaymentButton()}
						{this.renderImportUsersButton()}
					</div>
					<div className="top-row">
						<CardHeader>{this.state.userGroup && this.state.userGroup.name} Users</CardHeader>
					</div>
					{this._renderUsers()}
				</Card>
				<Card>
					<div className="top-row"><CardHeader className="account-settings">Super Admin Account Settings</CardHeader></div>
					<Label className="settings-header" black large>Drug Categories</Label>
					{this._renderCategories()}
					{this._renderIntegrations()}
					{this._renderSettings()}
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/groupUserListPage/GroupUserListPage.jsx